import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock, BlockType, SettingType, SettingState,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';

const PRESCALAR_OPTIONS = [
    {
        name: '500KHz for CPU clock of 32MHz',
        value: 'PIC_PRE_64',
    },
    {
        name: '2Mhz  for CPU clock of 32MHz',
        value: 'PIC_PRE_16',
    },
    {
        name: '8Mhz  for CPU clock of 32MHz',
        value: 'PIC_PRE_4',
    },
    {
        name: '32Mhz  for CPU clock of 32MHz',
        value: 'PIC_PRE_1',
    },
];

const MODES = [
    {
        name: 'PWM',
        value: 'PWM',
    },
    {
        name: 'ADC',
        value: 'ADC',
    },
];
const POSITIVE_VOLTAGE_REFERENCE = [
    {
        name: 'PIC_PREF_SOURCE_VDD (5V nominal), default selection',
        value: 'PIC_PREF_SOURCE_VDD',
    },
    {
        name: 'PIC_PREF_SOURCE_PIN_4 (For EM1000LEV only)',
        value: 'PIC_PREF_SOURCE_PIN_4',
    },
    {
        name: 'PIC_PREF_SOURCE_FVR_BUF',
        value: 'PIC_PREF_SOURCE_FVR_BUF',
    },
];

const NEGATIVE_VOLTAGE_REFERENCE = [
    {
        name: 'PIC_NREF_SOURCE_VSS (Default selection)',
        value: 'PIC_NREF_SOURCE_VSS',
    },
    {
        name: 'PIC_NREF_SOURCE_PIN_5 (For EM1000LEV only)',
        value: 'PIC_NREF_SOURCE_PIN_5',
    },
];

const FIXED_VOLTAGE_REFERENCE = [
    {
        name: 'Off',
        value: 'PIC_ADC_FVR_REF_OFF',
    },
    {
        name: '2048mV, 0 ~ 2.048V (based on PIC\'s internal reference)',
        value: 'PIC_ADC_FVR_REF_2048mV',
    },
    {
        name: '4096mV, 0 ~ 4.096V (based on PIC\'s internal reference)',
        value: 'PIC_ADC_FVR_REF_4096mV',
    },
];

export default class Tibbit_31 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_31';
        this.name = 'Tibbit 31';
        this.fileLinks = [
            // 'ssi\\ssi.tbs',
            // 'ssi\\ssi.tbh',
        ];
        this.files = [
            'libraries/super_i2c/super_i2c.tbh',
            'libraries/super_i2c/super_i2c.tbs',
            'libraries/pic/tbt_pic_gra.tbh',
            'libraries/pic/tbt_pic_gra.tbs',
            'libraries/ssi/ssi.tbh',
            'libraries/ssi/ssi.tbs',
        ];
        const settings = [
            {
                id: 'GENERAL',
                name: 'General',
                settingType: SettingType.GROUP,
                default: '',
            },
            {
                id: 'ADC',
                name: 'ADC',
                settingType: SettingType.GROUP,
                default: '',
            },
            {
                id: 'UART',
                name: 'UART',
                settingType: SettingType.GROUP,
                default: '',
            },
            {
                id: 'CH1',
                name: 'Channel 1',
                settingType: SettingType.GROUP,
                default: '',
            },
            {
                id: 'CH2',
                name: 'Channel 2',
                settingType: SettingType.GROUP,
                default: '',
            },
            {
                id: 'CH3',
                name: 'Channel 3',
                settingType: SettingType.GROUP,
                default: '',
            },
            {
                id: 'CH4',
                name: 'Channel 4',
                settingType: SettingType.GROUP,
                default: '',
            },
            {
                id: 'FIRMWARE',
                name: 'Firmware Upload',
                settingType: SettingType.GROUP,
                default: '',
            },
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                required: true,
                group: 'GENERAL',
                default: '',
            },
            {
                id: 'PR',
                name: 'Positive Voltage Reference',
                settingType: SettingType.OPTION,
                required: true,
                group: 'ADC',
                default: 'PIC_PREF_SOURCE_VDD',
                options: POSITIVE_VOLTAGE_REFERENCE,
            },
            {
                id: 'NR',
                name: 'Negative Voltage Reference',
                settingType: SettingType.OPTION,
                required: true,
                group: 'ADC',
                default: 'PIC_NREF_SOURCE_VSS',
                options: NEGATIVE_VOLTAGE_REFERENCE,
            },
            {
                id: 'FVR',
                name: 'Fixed Voltage Reference',
                settingType: SettingType.OPTION,
                required: true,
                group: 'ADC',
                default: 'PIC_ADC_FVR_REF_OFF',
                options: FIXED_VOLTAGE_REFERENCE,
            },
            {
                id: 'USESSI',
                name: 'Mode',
                settingType: SettingType.OPTION,
                required: true,
                group: 'GENERAL',
                readonly: true,
                default: 'NO',
                options: [
                    {
                        name: 'I2C mode',
                        value: 'YES',
                    },
                    {
                        name: 'Direct I/O (bit-banging)',
                        value: 'NO',
                    },
                ],
            },
            // {
            //     id: 'UARTENABLED',
            //     name: 'UART Mode',
            //     settingType: SettingType.OPTION,
            //     required: true,
            //     group: 'UART',
            //     default: '0',
            //     options: [
            //         {
            //             name: 'Disabled',
            //             value: '0',
            //         },
            //         {
            //             name: 'Enabled',
            //             value: '1',
            //         },
            //     ],
            // },
            {
                id: 'BAUD',
                name: 'Baudrate',
                settingType: SettingType.OPTION,
                required: true,
                group: 'UART',
                default: 'PIC_BRATE_57600',
                options: [
                    {
                        name: '300',
                        value: 'PIC_BRATE_300',
                    },
                    {
                        name: '600',
                        value: 'PIC_BRATE_600',
                    },
                    {
                        name: '1200',
                        value: 'PIC_BRATE_1200',
                    },
                    {
                        name: '2400',
                        value: 'PIC_BRATE_2400',
                    },
                    {
                        name: '4800',
                        value: 'PIC_BRATE_4800',
                    },
                    {
                        name: '9600',
                        value: 'PIC_BRATE_9600',
                    },
                    {
                        name: '19200',
                        value: 'PIC_BRATE_19200',
                    },
                    {
                        name: '38400',
                        value: 'PIC_BRATE_38400',
                    },
                    {
                        name: '57600',
                        value: 'PIC_BRATE_57600',
                    },
                ],
            },
            {
                id: 'PARITY',
                name: 'Parity',
                settingType: SettingType.OPTION,
                group: 'UART',
                required: true,
                default: 'PIC_PARITY_NONE',
                options: [
                    {
                        name: 'None',
                        value: 'PIC_PARITY_NONE',
                    },
                    {
                        name: 'Even',
                        value: 'PIC_PARITY_EVEN',
                    },
                    {
                        name: 'Odd',
                        value: 'PIC_PARITY_ODD',
                    },
                    {
                        name: 'Mark (Always 1)',
                        value: 'PIC_PARITY_MARK',
                    },
                    {
                        name: 'Space (Always 0)',
                        value: 'PIC_PARITY_SPACE',
                    },
                ],
            },
            {
                id: 'MODE1',
                name: 'Mode',
                settingType: SettingType.OPTION,
                required: true,
                group: 'CH1',
                default: 'PWM',
                options: MODES,
            },
            {
                id: 'PW1',
                name: 'Pulse Width',
                settingType: SettingType.NUMBER,
                required: true,
                group: 'CH1',
                default: '300',
            },
            {
                id: 'P1',
                name: 'Period',
                settingType: SettingType.NUMBER,
                required: true,
                group: 'CH1',
                default: '1000',
            },
            {
                id: 'S1',
                name: 'Prescaler',
                settingType: SettingType.OPTION,
                required: true,
                group: 'CH1',
                default: 'PIC_PRE_64',
                options: PRESCALAR_OPTIONS,
            },
            {
                id: 'D1',
                name: 'Initial duty cycle ratio',
                settingType: SettingType.NUMBER,
                required: true,
                group: 'CH1',
                default: '1000',
            },
            {
                id: 'MODE2',
                name: 'Mode',
                settingType: SettingType.OPTION,
                required: true,
                group: 'CH2',
                default: 'PWM',
                options: MODES,
            },
            {
                id: 'PW2',
                name: 'Pulse Width',
                settingType: SettingType.NUMBER,
                required: true,
                group: 'CH2',
                default: '300',
            },
            {
                id: 'P2',
                name: 'Period',
                settingType: SettingType.NUMBER,
                required: true,
                group: 'CH2',
                default: '1000',
            },
            {
                id: 'S2',
                name: 'Prescaler',
                settingType: SettingType.OPTION,
                required: true,
                group: 'CH2',
                default: 'PIC_PRE_64',
                options: PRESCALAR_OPTIONS,
            },
            {
                id: 'D2',
                name: 'Initial duty cycle ratio',
                settingType: SettingType.NUMBER,
                required: true,
                group: 'CH2',
                default: '1000',
            },
            {
                id: 'MODE3',
                name: 'Mode',
                settingType: SettingType.OPTION,
                required: true,
                group: 'CH3',
                default: 'PWM',
                options: MODES,
            },
            {
                id: 'PW3',
                name: 'Pulse Width',
                settingType: SettingType.NUMBER,
                required: true,
                group: 'CH3',
                default: '300',
            },
            {
                id: 'P3',
                name: 'Period',
                settingType: SettingType.NUMBER,
                required: true,
                group: 'CH3',
                default: '1000',
            },
            {
                id: 'S3',
                name: 'Prescaler',
                settingType: SettingType.OPTION,
                required: true,
                group: 'CH3',
                default: 'PIC_PRE_64',
                options: PRESCALAR_OPTIONS,
            },
            {
                id: 'D3',
                name: 'Initial duty cycle ratio',
                settingType: SettingType.NUMBER,
                required: true,
                group: 'CH3',
                default: '1000',
            },
            {
                id: 'MODE4',
                name: 'Mode',
                settingType: SettingType.OPTION,
                required: true,
                readonly: true,
                group: 'CH4',
                default: 'ADC',
                options: [{
                    name: 'ADC',
                    value: 'ADC',
                }],
            },
            {
                id: 'FIRMWAREFILE',
                name: 'Firmware to Upload',
                settingType: SettingType.FILE,
                required: true,
                group: 'FIRMWARE',
                default: '',
                max: 102400,
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getFiles() {
        const FIRMWAREFILE = this.getSettingValue('FIRMWAREFILE');
        const fileArray = [];
        if (FIRMWAREFILE !== '') {
            fileArray.push('libraries/pic/PIC_LVP.tbh');
            fileArray.push('libraries/pic/PIC_LVP.tbs');
            fileArray.push(FIRMWAREFILE.split('\n')[0]);
        }
        return this.files.concat(fileArray);
    }

    getState(settingId: string): SettingState {
        const FIRMWAREFILE = this.getSettingValue('FIRMWAREFILE');
        if (FIRMWAREFILE !== '') {
            if (settingId !== 'FIRMWARE' && settingId !== 'FIRMWAREFILE') {
                return SettingState.HIDDEN;
            }
        }
        const CH1MODE = this.getSettingValue('MODE1');
        const CH2MODE = this.getSettingValue('MODE2');
        const CH3MODE = this.getSettingValue('MODE3');
        const UARTENABLED = this.getSettingValue('UARTENABLED');
        if (UARTENABLED === '1') {
            switch (settingId) {
                case 'NAME':
                case 'USESSI':
                case 'UARTENABLED':
                case 'BAUD':
                case 'PARITY':
                    return SettingState.ENABLED;
                default:
                    return SettingState.HIDDEN;
            }
        }
        switch (settingId) {
            case 'PW1':
            case 'P1':
            case 'S1':
            case 'D1':
                return CH1MODE === 'PWM' ? SettingState.ENABLED : SettingState.HIDDEN;
            case 'PR1':
            case 'NR1':
            case 'FVR1':
                return CH1MODE === 'ADC' ? SettingState.ENABLED : SettingState.HIDDEN;
            case 'PW2':
            case 'P2':
            case 'S2':
            case 'D2':
                return CH2MODE === 'PWM' ? SettingState.ENABLED : SettingState.HIDDEN;
            case 'PR2':
            case 'NR2':
            case 'FVR2':
                return CH2MODE === 'ADC' ? SettingState.ENABLED : SettingState.HIDDEN;
            case 'PW3':
            case 'P3':
            case 'S3':
            case 'D3':
                return CH3MODE === 'PWM' ? SettingState.ENABLED : SettingState.HIDDEN;
            case 'PR3':
            case 'NR3':
            case 'FVR3':
                return CH3MODE === 'ADC' ? SettingState.ENABLED : SettingState.HIDDEN;
            case 'BAUD':
            case 'PARITY':
                return SettingState.HIDDEN;
            default:

                return SettingState.ENABLED;
        }
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        if (this.project.runtime === 'simulator') {
            return [];
        }

        const socket = Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id);
        const NAME = this.getSettingValue('NAME');
        const UARTENABLED = this.getSettingValue('UARTENABLED');
        const CHANNEL = `${NAME}_CHANNEL`;
        const interruptNumber = Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id)?.interrupt;
        const interruptEnum = PlatformUtils.getEnum(interruptNumber, 'pl_int_num', this.project.device.platform);
        const FIRMWAREFILE = this.getSettingValue('FIRMWAREFILE');

        if (FIRMWAREFILE !== '') {
            const pins = Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id);
            const fileName = FIRMWAREFILE.split('\n')[0];
            blocks.push({
                location: 'boot',
                blockType: BlockType.CODE,
                template: `
    pic_lvp_start(${pins[0]},${pins[1]}, ${pins[2]})
    sys.debugprint("Programming PIC coprocessor with new firmware.\\r\\n")
    sys.debugprint("Please be patient. This can take a while.\\r\\n")
    if not pic_lvp_upload_firmware("${fileName}") then
        sys.debugprint("Error programming PIC coprocessor.\\r\\n")
        sys.halt()
    end if`,
            });
            return blocks;
        }

        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `
declare ${CHANNEL} as byte`,
        });

        blocks.push({
            location: 'GLOBAL_DIMS',
            blockType: BlockType.CODE,
            template: `dim ${CHANNEL} as byte`,
        });

        const USESSI = this.getSettingValue('USESSI');

        let bootStr = `
    'Tibbit 31 setup on socket ${this.getSettingValue('SOCKET')}
    '================================================================
    dim ${NAME}_pic_fw_str as string
    ${NAME}.PIC_CLK_PIN=${socket?.pins[0]}
    ${NAME}.PIC_DATA_PIN=${socket?.pins[1]}
    ${NAME}.PIC_RST_PIN=${socket?.pins[2]}
    ${NAME}.PIC_INT_PIN=${socket?.pins[3]}
    select case tbt_pic_gra_init("${NAME}",${NAME},${USESSI},${NAME}_pic_fw_str)
    case PIC_NG:
        sys.debugprint("SSI channel could not be allocated, using bit banging instead.\\r\\n")
        
    case PIC_REJ:
        sys.debugprint("The CPU clock is too slow for the SSI to be used. Bit banging used instead.\\r\\n")

    case PIC_FWNG:
        if ${NAME}_pic_fw_str="" then ${NAME}_pic_fw_str="<No version string returned>"
        sys.debugprint("PIC firmware version mismatch or PIC not present.\\r\\n")
        sys.debugprint("PIC reported this firmware version: \\r\\n"+${NAME}_pic_fw_str)
        sys.debugprint("This application expects the following firmware: "+EXPECTED_PIC_FIRMWARE_V+".XX\\r\\n")
        sys.halt
    end select`;
        if (UARTENABLED === '1') {
            bootStr += `
    'UART setup
    pic_config(PIC_PIN0,PIC_FUNC_UART,${NAME}_INT,${CHANNEL})
    pic_config(PIC_PIN1,PIC_FUNC_UART,${NAME}_INT,${CHANNEL})
    pic_ser_config(${this.getSettingValue('BAUD')},${this.getSettingValue('PARITY')},YES,${CHANNEL})
    'To send data:
    'pic_ser_setsend("${NAME}",${CHANNEL})
    'while pic_ser_txlen(${CHANNEL})<>0
    'wend

    'To receive data:
    'while pic_ser_rxlen(${CHANNEL})=0
    'wend
    'sys.debugprint(pic_ser_get(${CHANNEL}))`;
        } else {
            const duty_cycles = [0, 0, 0];
            for (let i = 0; i < 4; i += 1) {
                const CH = (i + 1).toString();
                let mode = this.getSettingValue(`MODE${CH}`);
                if (i === 4) {
                    mode = 'ADC';
                }
                if (mode === 'PWM') {
                    bootStr += `
        tbt_pic_gra_config(${NAME},PIC_PIN${i.toString()},PIC_FUNC_PWM)`;
                } else {
                    bootStr += `
        tbt_pic_gra_config(${NAME},PIC_PIN${i.toString()},PIC_FUNC_ADC)`;
                }
            }
            bootStr += `
        'tbt_pic_adc_config(${this.getSettingValue('PR')},${this.getSettingValue('NR')},${this.getSettingValue('FVR')},${CHANNEL})`;
        }

        bootStr += `
    '-----------------------------------------------------------------`;

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: bootStr,
        });

        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `
declare ${NAME} as tbt_pic_gra`,
        });

        blocks.push({
            location: 'GLOBAL_DIMS',
            blockType: BlockType.CODE,
            template: `
dim ${NAME} as tbt_pic_gra`,
        });


        return blocks;
    }
}
